/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const EllipsisHorizontalIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M2.6 12a2.05 2.05 0 1 1 4.1 0 2.05 2.05 0 0 1-4.1 0m7.35 0a2.05 2.05 0 1 1 4.1 0 2.05 2.05 0 0 1-4.1 0m7.35 0a2.05 2.05 0 1 1 4.1 0 2.05 2.05 0 0 1-4.1 0" clipRule="evenodd" /></svg>;
};
export default EllipsisHorizontalIcon;